<template>
  <div class="mxsyssb-wrap">
    <div style="width:100%;height:356px"></div>
    <div class="mxsyssb">
      <div class="sta-title">
          名下实验室设备信息
      </div>
      <div class="sta-more" style="margin-bottom:54px">
          More
          <div class="sta-more1"></div>
      </div>
      <div class="mxsyssb-items">
        <div class="mxsyssb-item-wrap" v-for="(item,index) in assetList" :key="index">
          <div class="mxsyssb-item">
            <div class="mxsyssb-item1">
                <div class="mxsyssb-item11">{{item.rowData.shul}}</div>
                <div class="mxsyssb-item12">{{item.rowData.danw}}</div>
            </div>
            <div class="mxsyssb-item2">{{"¥"+item.rowData.jine}}</div>
            <div class="mxsyssb-item3">{{item.rowData.hangyflName}}</div>
            <div class="mxsyssb-item4">{{item.rowData.cunfddName}}</div>
            <div class="mxsyssb-item5">
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-a-24_SY_A_sedu_morendechangjiantou"></use>
              </svg>
            </div>
            <div class="mxsyssb-item6"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
        assetList:[]
    }
  },
  methods: {
      getdanwei(danw){
          if(danw == '平方米'){
              return "m²"
          }else{
              return '台'
          }
      },
      getmxfw(){
          let paramter = {}
          GMS.$http.post('/own/lab/list',paramter).then(res=>{
            if(res.status == 200){
                 let data = res.data.extraData
                  this.assetList = data;
            }
        }).catch(error => {
            // this.$Message.error("获取数据异常，请联系管理员");
        })
      }
  },
  mounted(){
      this.getmxfw()
  }
}
</script>

<style lang="less" scoped>
.mxsyssb-wrap{
  width: 100%;
  height: 958px;
  .mxsyssb{
    width: 1200px;
    margin: 0 auto;
  }
  .sta-title{
        height: 42px;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        font-size: 30px;
        color: #424242;
        letter-spacing: 0;
        line-height: 42px;
        text-align: center;
        margin-bottom: 24px;
    }
    .sta-more{
        width: 39px;
        height: 22px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 16px;
        color: #7F7F7F;
        line-height: 22px;
        position: relative;
        margin: 0 auto;
        margin-bottom: 54px;
    }
    .sta-more1{
        position: absolute;
        left: 47px;
        bottom: 4px;
        width: 14px;
        height: 10px;  
        background: url('../../../static/statistics/more@2x.webp'); 
        background-size: 14px 10px;
    }
    .mxsyssb-item-wrap{
      float: left;
      width: 270px;
      height: 360px;
      background: #FFFFFF;
      box-shadow: 0 0 20px 0 rgba(0,0,0,0.10);
      position: relative;
      transition: background-color 0.25s ease-out;
      -ms-transition: background-color 0.25s ease-out;
      -o-transition: background-color 0.25s ease-out;
      -moz-transition: background-color 0.25s ease-out;
      -webkit-transition: background-color 0.25s ease-out;
    }
    .mxsyssb-item-wrap:nth-child(2){
      margin-left: 40px;
    }
    .mxsyssb-item-wrap:nth-child(3){
      margin-left: 40px;
      margin-right: 40px;
    }
    .mxsyssb-item-wrap:hover{
      background-color:#003670;
      .mxsyssb-item11{
        color: #fff;
      }
      .mxsyssb-item12{
        color: #fff;
      }
      .mxsyssb-item2{
        color: #fff;
      }
      .mxsyssb-item3{
        color: #fff;
      }
      .mxsyssb-item4{
        color: #fff;
      }
    }
    .mxsyssb-item{
      float: left;
      margin-left: 40px;
      margin-top: 45px;
      width: 190px;
    }
    .mxsyssb-item1{
      height: 70px;
      margin-bottom: 11px;
      .mxsyssb-item11{
        float: left;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        font-size: 50px;
        color: #003670;
        text-align: right;
        margin-right: 6px;
      }
      .mxsyssb-item12{
        float: left;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 16px;
        color: #7F7F7F;
        margin-top: 28px;
      }
    }
    .mxsyssb-item2{
      height: 25px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 18px;
      color: #7F7F7F;
      line-height: 25px;
      margin-bottom: 24px;
    }
    .mxsyssb-item3{
      height: 22px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 16px;
      color: #0F0F0F;
      line-height: 22px;
      margin-bottom: 24px;
    }
    .mxsyssb-item4{
      height: 22px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 16px;
      color: #787878;
      line-height: 22px;
      margin-bottom: 44px;
    }
    .mxsyssb-item6{
      position: absolute;
      left: 0;
      bottom: 0;
      width: 270px;
      height: 4px;
      background: #FF9D00;
    }
    
}
</style>



// WEBPACK FOOTER //
// src/components/Statistics/mxsyssb.vue